import React from 'react'
import { Carousel, Row } from 'antd';
import { Col, Div, Img, Text } from './styles';
import icon1 from './icons/icon1.svg'
import icon2 from './icons/icon2.svg'
import icon3 from './icons/icon3.svg'
import icon4 from './icons/icon4.svg'
import icon5 from './icons/icon5.svg'
import icon6 from './icons/icon6.svg'
import icon7 from './icons/icon7.svg'


export const SliderCualidades = () => {

    var settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
      };

    var settingImg = {
        with: 100,
        preview: false
    };

    return (
        <Carousel {...settings} style={{ textAlign: 'center', background: '#f5f5f5' }}>
                <Div>
                    <Img src={icon1} {...settingImg} alt="icon1" />
                    <Text>Cuidamos el Medio Ambiente</Text>
                </Div>
                <Div>
                    <Img src={icon2} {...settingImg} alt="icon2" />
                    <Text>Extractos Naturales</Text>
                </Div>
                <Div>
                    <Img src={icon3} {...settingImg} alt="icon3" />
                    <Text>Productos de Calidad</Text>
                </Div>
                <Div>
                    <Img src={icon4} {...settingImg} alt="icon4" />
                    <Text>Certificados</Text>
                </Div>
                <Div>
                    <Img src={icon5} {...settingImg} alt="icon5" />
                    <Text>Precios Competitivos</Text>
                </Div>
                <Div>
                    <Img src={icon6} {...settingImg} alt="icon6" />
                    <Text>Envio Gratis</Text>
                </Div>
                <Div>
                    <Img src={icon7} {...settingImg} alt="icon7" />
                    <Text>100% Hecho en Colombia</Text>
                </Div>
        </Carousel>
    )
}